import { FormattedMessage } from "react-intl";

import { Badge } from "@ps-design-system/components/Badge";
import { Text } from "@ps-design-system/components/Text";

import { HOST_HUB_TAB_IDS } from "../constants/host-hub.consts";

import type { HostHubLayoutProps } from "./HostHubLayout.types";
import HostHubMetrics from "./HostHubMetrics";
import HostHubNavigation from "./HostHubNavigation";
import HostHubOverview from "./HostHubOverview";

const HostHubLayout = ({
  activeTabId,
  email,
  firstName,
  lastName,
  onActiveTabIdChange,
  SSOid,
}: HostHubLayoutProps) => {
  const isMetricsTab = activeTabId === HOST_HUB_TAB_IDS.metrics;
  const titleMessage = isMetricsTab
    ? { defaultMessage: "Metrics", id: "host_hub.tab.metrics" }
    : {
        defaultMessage: "Welcome back",
        id: "host_hub.mobile_title",
      };
  const titleBadge = isMetricsTab ? (
    <Badge appearance="purple" size="sm">
      <FormattedMessage
        defaultMessage="Coming soon"
        id="host_hub.metrics.coming_soon_badge"
      />
    </Badge>
  ) : null;
  const tabContent = isMetricsTab ? (
    <HostHubMetrics
      email={email}
      firstName={firstName}
      lastName={lastName}
      SSOid={SSOid}
    />
  ) : (
    <HostHubOverview />
  );

  return (
    <div className="host-hub-page tw-flex tw-min-h-[calc(100dvh-72px)] tw-flex-col tw-bg-gray-100">
      <div className="tw-sticky tw-top-[72px] tw-z-10 tw-bg-brand-white">
        <HostHubNavigation
          activeTabId={activeTabId}
          onActiveTabIdChange={onActiveTabIdChange}
        />
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-[32px] tw-bg-brand-white tw-px-[16px] tw-pb-0 tw-pt-[24px] lg:tw-bg-transparent lg:tw-gap-[40px] lg:tw-px-[160px] lg:tw-pb-[64px] lg:tw-pt-[40px]">
        <div className="tw-flex tw-items-center tw-gap-[12px]">
          <Text
            className="tw-my-0 lg:tw-headline-6-m"
            element="h1"
            typeface="headline-3-m"
          >
            <FormattedMessage {...titleMessage} />
          </Text>
          {titleBadge}
        </div>
        {tabContent}
      </div>
    </div>
  );
};

export default HostHubLayout;
